import orders from './list/sagas'
import searchAddressWithNo from './searchAddressWithNo/sagas'
import create from './create/sagas'

export default [orders, searchAddressWithNo, create]
